/*
 * Copyright (c) 2019 Signum+ Software & Facility GmbH
 * Author: jahn@signum-plus.at
 */

export interface HostInfoData {
  time?: string;
  version?: string;
}

export class HostInfo implements HostInfoData {
  public readonly time: string;
  public readonly version: string;

  constructor(data: HostInfoData) {
    this.time = data.time;
    this.version = data.version;
  }
}
